import React from 'react';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BootstrapSwitchButton from 'bootstrap-switch-button-react';
import {
  UpdateCarProtection,
  AddMedia,
  getCarProtectionListing,
} from './../../../../Redux/Actions/UserAction';
import Sidebar from '../../../common/Sidebar/Sidebar';
import { timeOptions } from '../../../../Options';
import { useTranslation } from 'react-i18next';
import { CommonBusinessHeader } from '../CommonBusinessHeader';

const openStatus = ['OPEN', 'مفتوح'];

const CarProtectionWorkingHours = () => {
  const { t } = useTranslation();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: 'all' });

  const dispatch = useDispatch();
  const home = useSelector((state) => state?.home);
  const packagesAll = home?.getCarProtectionList?.[0]?.packages;
  const getCarProtectionList = home?.getCarProtectionList;
  const getMybusiness = home?.getMybusiness;

  // After a save the action reloads the page, which wipes the store. The
  // business id arrives either from Redux (getMybusiness) or sessionStorage
  // (set by the Header once /business/my resolves) — fetch the owner's listing
  // as soon as it's known so the form repopulates after a reload.
  const ownerBid =
    (getMybusiness?.businessId && String(getMybusiness.businessId)) ||
    sessionStorage.getItem('BusinessId');
  const validBid =
    ownerBid && ownerBid !== 'undefined' && ownerBid !== 'null' && ownerBid !== '';

  useEffect(() => {
    if (validBid) {
      dispatch(getCarProtectionListing(ownerBid));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ownerBid]);

  const [CarProtectionData, setCarProtectionData] = useState({
    calendar: {
      SUNDAY: {
        status: 'OPEN',
        openTime: '',
        endTime: '',
      },
      MONDAY: {
        status: 'OPEN',
        openTime: '',
        endTime: '',
      },
      TUESDAY: {
        status: 'CLOSE',
      },
      WEDNESDAY: {
        status: 'OPEN',
        openTime: '',
        endTime: '',
      },
      THURSDAY: {
        status: 'OPEN',
        openTime: '',
        endTime: '',
      },
      FRIDAY: {
        status: 'OPEN',
        openTime: '',
        endTime: '',
      },
      SATURDAY: {
        status: 'OPEN',
        openTime: '',
        endTime: '',
      },
    },
  });

  useEffect(() => {
    if (getCarProtectionList?.length > 0) {
      let calendar;
      try {
        calendar =
          typeof getCarProtectionList?.[0]?.calendar === 'string'
            ? JSON.parse(getCarProtectionList?.[0]?.calendar)
            : getCarProtectionList?.[0]?.calendar;
      } catch (e) {
        calendar = undefined;
      }
      setCarProtectionData({
        calendar: {
          SUNDAY: {
            status: calendar?.SUNDAY?.status,
            openTime: calendar?.SUNDAY?.openTime,
            endTime: calendar?.SUNDAY?.endTime,
          },
          MONDAY: {
            status: calendar?.MONDAY?.status,
            openTime: calendar?.MONDAY?.openTime,
            endTime: calendar?.MONDAY?.endTime,
          },
          TUESDAY: {
            status: calendar?.TUESDAY?.status,
            openTime: calendar?.TUESDAY?.openTime,
            endTime: calendar?.TUESDAY?.endTime,
          },
          WEDNESDAY: {
            status: calendar?.WEDNESDAY?.status,
            openTime: calendar?.WEDNESDAY?.openTime,
            endTime: calendar?.WEDNESDAY?.endTime,
          },
          THURSDAY: {
            status: calendar?.THURSDAY?.status,
            openTime: calendar?.THURSDAY?.openTime,
            endTime: calendar?.THURSDAY?.endTime,
          },
          FRIDAY: {
            status: calendar?.FRIDAY?.status,
            openTime: calendar?.FRIDAY?.openTime,
            endTime: calendar?.FRIDAY?.endTime,
          },
          SATURDAY: {
            status: calendar?.SATURDAY?.status,
            openTime: calendar?.SATURDAY?.openTime,
            endTime: calendar?.SATURDAY?.endTime,
          },
        },
      });
    }
  }, [getCarProtectionList]);

  const handleChange = (e) => {
    console.log('e is the value', e);

    if (e.target.id === 'SUNDAY') {
      setCarProtectionData({
        ...CarProtectionData,
        calendar: {
          ...CarProtectionData.calendar,
          SUNDAY: {
            ...CarProtectionData.calendar.SUNDAY,
            [e.target.name]: e.target.value,
          },
        },
      });
    } else if (e.target.id === 'MONDAY') {
      setCarProtectionData({
        ...CarProtectionData,
        calendar: {
          ...CarProtectionData.calendar,
          MONDAY: {
            ...CarProtectionData.calendar.MONDAY,
            [e.target.name]: e.target.value,
          },
        },
      });
    } else if (e.target.id === 'TUESDAY') {
      setCarProtectionData({
        ...CarProtectionData,
        calendar: {
          ...CarProtectionData.calendar,
          TUESDAY: {
            ...CarProtectionData.calendar.TUESDAY,
            [e.target.name]: e.target.value,
          },
        },
      });
    } else if (e.target.id === 'WEDNESDAY') {
      setCarProtectionData({
        ...CarProtectionData,
        calendar: {
          ...CarProtectionData.calendar,
          WEDNESDAY: {
            ...CarProtectionData.calendar.WEDNESDAY,
            [e.target.name]: e.target.value,
          },
        },
      });
    } else if (e.target.id === 'THURSDAY') {
      setCarProtectionData({
        ...CarProtectionData,
        calendar: {
          ...CarProtectionData.calendar,
          THURSDAY: {
            ...CarProtectionData.calendar.THURSDAY,
            [e.target.name]: e.target.value,
          },
        },
      });
    } else if (e.target.id === 'FRIDAY') {
      setCarProtectionData({
        ...CarProtectionData,
        calendar: {
          ...CarProtectionData.calendar,
          FRIDAY: {
            ...CarProtectionData.calendar.FRIDAY,
            [e.target.name]: e.target.value,
          },
        },
      });
    } else if (e.target.id === 'SATURDAY') {
      setCarProtectionData({
        ...CarProtectionData,
        calendar: {
          ...CarProtectionData.calendar,
          SATURDAY: {
            ...CarProtectionData.calendar.SATURDAY,
            [e.target.name]: e.target.value,
          },
        },
      });
    }
  };

  const datasubmit = () => {
    console.log('tihs is image section', CarProtectionData);
    dispatch(UpdateCarProtection(CarProtectionData));
  };

  const ResetHendler = () => {
    setCarProtectionData({
      calendar: {
        SUNDAY: {
          status: 'CLOSE',
          openTime: '',
          endTime: '',
        },
        MONDAY: {
          status: 'CLOSE',
          openTime: '',
          endTime: '',
        },
        TUESDAY: {
          status: 'CLOSE',
          openTime: '',
          endTime: '',
        },
        WEDNESDAY: {
          status: 'CLOSE',
          openTime: '',
          endTime: '',
        },
        THURSDAY: {
          status: 'CLOSE',
          openTime: '',
          endTime: '',
        },
        FRIDAY: {
          status: 'CLOSE',
          openTime: '',
          endTime: '',
        },
        SATURDAY: {
          status: 'CLOSE',
          openTime: '',
          endTime: '',
        },
      },
    });
  };

  const sideBarOpt = [
    {
      icon: 'assets/images/icons/sp-business/manage-business.svg',
      link: '/sp-car-protection-business',
      label: t('Manage Business'),
    },
    {
      icon: 'assets/images/icons/sp-business/manage-service.svg',
      link: '/sp-car-protection-packages',
      label: t('Manage Packages'),
    },
    {
      icon: 'assets/images/icons/sp-business/banner.svg',
      link: '/sp-car-protection-banner',
      label: t('Banner'),
    },
    {
      icon: 'assets/images/icons/sp-business/manage-working-hours.svg',
      link: '/sp-car-protection-working-hours',
      label: t('Manage Working Hours'),
    },
  ];

  return (
    <div>
      <CommonBusinessHeader
        dataList={getCarProtectionList}
        getNameKey="carProtectionName"
      />

      <div class="main-content-area">
        <div class="container">
          <div class="row justify-content-between">
            <Sidebar options={sideBarOpt} />

            <div class="col-12 col-sm-12 col-md-9 col-lg-9">
              <h2 class="mb-4">{t('Manage Working Hours')}</h2>
              <form onSubmit={handleSubmit(datasubmit)}>
                <div class="mwh-row">
                  <div class="row align-items-center">
                    <div class="col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-day">{t('Day')}</div>
                    </div>
                    <div class="col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="mwh-day">{t('From')}</label>
                    </div>
                    <div class="col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="mwh-day">{t('To')}</label>
                    </div>
                  </div>
                </div>
                <div class="mwh-row">
                  <div class="row align-items-center">
                    <div class="col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-day">{t('Sunday')}</div>
                    </div>

                    <div class="col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        name="openTime"
                        id="SUNDAY"
                        value={CarProtectionData.calendar.SUNDAY.openTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            CarProtectionData.calendar.SUNDAY.status
                          )
                        }
                      >
                        <option>{t('From')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        id="SUNDAY"
                        name="endTime"
                        value={CarProtectionData.calendar.SUNDAY.endTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            CarProtectionData.calendar.SUNDAY.status
                          )
                        }
                      >
                        <option>{t('To')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-3 col-sm-3 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-switch">
                        <div class="form-check form-check-inline">
                          <BootstrapSwitchButton
                            width={70}
                            checked={
                              openStatus.includes(
                                CarProtectionData.calendar.SUNDAY.status
                              )
                                ? true
                                : false
                            }
                            onstyle="warning"
                            onlabel={t('open')}
                            offlabel={t('close')}
                            name="status"
                            id="SUNDAY"
                            onChange={(checked) => {
                              setCarProtectionData({
                                ...CarProtectionData,
                                calendar: {
                                  ...CarProtectionData.calendar,
                                  SUNDAY: {
                                    ...CarProtectionData.calendar.SUNDAY,

                                    status: checked ? 'OPEN' : 'CLOSE',
                                  },
                                },
                              });
                            }}

                            // value={CarProtectionData.status}
                          />
                          {/* <input
														class='form-check-input'
														type='checkbox'
														id='inlineCheckbox1'
														value='option1'
													/> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mwh-row">
                  <div class="row align-items-center">
                    <div class="col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-day">{t('Monday')}</div>
                    </div>

                    <div class="col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        name="openTime"
                        id="MONDAY"
                        value={CarProtectionData.calendar.MONDAY.openTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            CarProtectionData.calendar.MONDAY.status
                          )
                        }
                      >
                        <option>{t('From')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        id="MONDAY"
                        name="endTime"
                        value={CarProtectionData.calendar.MONDAY.endTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            CarProtectionData.calendar.MONDAY.status
                          )
                        }
                      >
                        <option>{t('To')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-3 col-sm-3 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-switch">
                        <div class="form-check form-check-inline">
                          <BootstrapSwitchButton
                            width={70}
                            checked={
                              openStatus.includes(
                                CarProtectionData.calendar.MONDAY.status
                              )
                                ? true
                                : false
                            }
                            onstyle="warning"
                            onlabel={t('open')}
                            offlabel={t('close')}
                            name="status"
                            id="MONDAY"
                            onChange={(checked) => {
                              setCarProtectionData({
                                ...CarProtectionData,
                                calendar: {
                                  ...CarProtectionData.calendar,
                                  MONDAY: {
                                    ...CarProtectionData.calendar.MONDAY,

                                    status: checked ? 'OPEN' : 'CLOSE',
                                  },
                                },
                              });
                            }}
                          />
                          {/* <input
														class='form-check-input'
														type='checkbox'
														id='inlineCheckbox2'
														value='option2'
													/> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mwh-row">
                  <div class="row align-items-center">
                    <div class="col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-day">{t('Tuesday')}</div>
                    </div>

                    <div class="col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        name="openTime"
                        id="TUESDAY"
                        value={CarProtectionData.calendar.TUESDAY.openTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            CarProtectionData.calendar.TUESDAY.status
                          )
                        }
                      >
                        <option>{t('From')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        id="TUESDAY"
                        name="endTime"
                        value={CarProtectionData.calendar.TUESDAY.endTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            CarProtectionData.calendar.TUESDAY.status
                          )
                        }
                      >
                        <option>{t('To')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-3 col-sm-3 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-switch">
                        <div class="form-check form-check-inline">
                          <BootstrapSwitchButton
                            width={70}
                            checked={
                              openStatus.includes(
                                CarProtectionData.calendar.TUESDAY.status
                              )
                                ? true
                                : false
                            }
                            onstyle="warning"
                            onlabel={t('open')}
                            offlabel={t('close')}
                            name="status"
                            id="TUESDAY"
                            onChange={(checked) => {
                              setCarProtectionData({
                                ...CarProtectionData,
                                calendar: {
                                  ...CarProtectionData.calendar,
                                  TUESDAY: {
                                    ...CarProtectionData.calendar.TUESDAY,

                                    status: checked ? 'OPEN' : 'CLOSE',
                                  },
                                },
                              });
                            }}
                          />
                          {/* <input
														class='form-check-input'
														type='checkbox'
														id='inlineCheckbox3'
														value='option3'
													/> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mwh-row">
                  <div class="row align-items-center">
                    <div class="col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-day">{t('Wednesday')}</div>
                    </div>

                    <div class="col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        name="openTime"
                        id="WEDNESDAY"
                        value={CarProtectionData.calendar.WEDNESDAY.openTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            CarProtectionData.calendar.WEDNESDAY.status
                          )
                        }
                      >
                        <option>{t('From')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        id="WEDNESDAY"
                        name="endTime"
                        value={CarProtectionData.calendar.WEDNESDAY.endTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            CarProtectionData.calendar.WEDNESDAY.status
                          )
                        }
                      >
                        <option>{t('To')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-3 col-sm-3 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-switch">
                        <div class="form-check form-check-inline">
                          <BootstrapSwitchButton
                            width={70}
                            checked={
                              openStatus.includes(
                                CarProtectionData.calendar.WEDNESDAY.status
                              )
                                ? true
                                : false
                            }
                            onstyle="warning"
                            onlabel={t('open')}
                            offlabel={t('close')}
                            name="status"
                            id="WEDNESDAY"
                            onChange={(checked) => {
                              setCarProtectionData({
                                ...CarProtectionData,
                                calendar: {
                                  ...CarProtectionData.calendar,
                                  WEDNESDAY: {
                                    ...CarProtectionData.calendar.WEDNESDAY,

                                    status: checked ? 'OPEN' : 'CLOSE',
                                  },
                                },
                              });
                            }}
                          />
                          {/* <input
														class='form-check-input'
														type='checkbox'
														id='inlineCheckbox4'
														value='option4'
													/> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mwh-row">
                  <div class="row align-items-center">
                    <div class="col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-day">{t('Thursday')}</div>
                    </div>

                    <div class="col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        name="openTime"
                        id="THURSDAY"
                        value={CarProtectionData.calendar.THURSDAY.openTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            CarProtectionData.calendar.THURSDAY.status
                          )
                        }
                      >
                        <option>{t('From')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        id="THURSDAY"
                        name="endTime"
                        value={CarProtectionData.calendar.THURSDAY.endTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            CarProtectionData.calendar.THURSDAY.status
                          )
                        }
                      >
                        <option>{t('To')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-3 col-sm-3 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-switch">
                        <div class="form-check form-check-inline">
                          <BootstrapSwitchButton
                            width={70}
                            checked={
                              openStatus.includes(
                                CarProtectionData.calendar.THURSDAY.status
                              )
                                ? true
                                : false
                            }
                            onstyle="warning"
                            onlabel={t('open')}
                            offlabel={t('close')}
                            name="status"
                            id="THURSDAY"
                            onChange={(checked) => {
                              setCarProtectionData({
                                ...CarProtectionData,
                                calendar: {
                                  ...CarProtectionData.calendar,
                                  THURSDAY: {
                                    ...CarProtectionData.calendar.THURSDAY,

                                    status: checked ? 'OPEN' : 'CLOSE',
                                  },
                                },
                              });
                            }}
                          />
                          {/* <input
														class='form-check-input'
														type='checkbox'
														id='inlineCheckbox5'
														value='option5'
													/> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mwh-row">
                  <div class="row align-items-center">
                    <div class="col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-day">{t('Friday')}</div>
                    </div>

                    <div class="col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        name="openTime"
                        id="FRIDAY"
                        value={CarProtectionData.calendar.FRIDAY.openTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            CarProtectionData.calendar.FRIDAY.status
                          )
                        }
                      >
                        <option>{t('From')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        id="FRIDAY"
                        name="endTime"
                        value={CarProtectionData.calendar.FRIDAY.endTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            CarProtectionData.calendar.FRIDAY.status
                          )
                        }
                      >
                        <option>{t('To')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-3 col-sm-3 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-switch">
                        <div class="form-check form-check-inline">
                          <BootstrapSwitchButton
                            width={70}
                            checked={
                              openStatus.includes(
                                CarProtectionData.calendar.FRIDAY.status
                              )
                                ? true
                                : false
                            }
                            onstyle="warning"
                            onlabel={t('open')}
                            offlabel={t('close')}
                            name="status"
                            id="FRIDAY"
                            onChange={(checked) => {
                              setCarProtectionData({
                                ...CarProtectionData,
                                calendar: {
                                  ...CarProtectionData.calendar,
                                  FRIDAY: {
                                    ...CarProtectionData.calendar.FRIDAY,

                                    status: checked ? 'OPEN' : 'CLOSE',
                                  },
                                },
                              });
                            }}
                          />
                          {/* <input
														class='form-check-input'
														type='checkbox'
														id='inlineCheckbox6'
														value='option6'
													/> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mwh-row">
                  <div class="row align-items-center">
                    <div class="col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-day">{t('Saturday')}</div>
                    </div>

                    <div class="col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        name="openTime"
                        id="SATURDAY"
                        value={CarProtectionData.calendar.SATURDAY.openTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            CarProtectionData.calendar.SATURDAY.status
                          )
                        }
                      >
                        <option>{t('From')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        id="SATURDAY"
                        name="endTime"
                        value={CarProtectionData.calendar.SATURDAY.endTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            CarProtectionData.calendar.SATURDAY.status
                          )
                        }
                      >
                        <option>{t('To')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-3 col-sm-3 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-switch">
                        <div class="form-check form-check-inline">
                          <BootstrapSwitchButton
                            width={70}
                            checked={
                              openStatus.includes(
                                CarProtectionData.calendar.SATURDAY.status
                              )
                                ? true
                                : false
                            }
                            onstyle="warning"
                            onlabel={t('open')}
                            offlabel={t('close')}
                            name="status"
                            id="SATURDAY"
                            onChange={(checked) => {
                              setCarProtectionData({
                                ...CarProtectionData,
                                calendar: {
                                  ...CarProtectionData.calendar,
                                  SATURDAY: {
                                    ...CarProtectionData.calendar.SATURDAY,

                                    status: checked ? 'OPEN' : 'CLOSE',
                                  },
                                },
                              });
                            }}
                          />
                          {/* <input
														class='form-check-input'
														type='checkbox'
														id='inlineCheckbox7'
														value='option7'
													/> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mt-5 ">
                  <div class="col-6">
                    <button
                      type="reset"
                      // onClick={ResetHendler}
                      class="btn btn-secondary btn-block"
                      href="#"
                      onClick={ResetHendler}
                      // role='button'
                    >
                      {t('Reset')}
                    </button>
                  </div>
                  <div class="col-6">
                    <button
                      type="submit"
                      // to='/sp-garages-packages'
                      class="btn btn-warning btn-block"
                      // href='sp-garages-manage-business-packages.html'
                      // role='button'
                    >
                      {t('Submit')}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarProtectionWorkingHours;
